<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('warehourse.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('warehourse.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('add_new')
            }}
          </ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.location_name_kh }}</td>
          <td>{{ record.location_name_en }}</td>
          <td>
            <span class="badge badge-success" v-if="record.is_main_warehouse">Yes</span>
            <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="text-center ts-space-x-3">
            <a href="#" v-tooltip="$t('edit')" class="text-primary" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('warehourse.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
      >
        <from-action @cancel="() => (showForm = false)" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'warehourseIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('stock/warehourse', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.stock.warehourse.search
      },
      set(newValue) {
        this.$store.commit('stock/warehourse/SET_SEARCH', newValue)
        this.$store.commit('stock/warehourse/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('warehourse.nameKh') },
        { name: this.$t('warehourse.nameEn') },
        { name: this.$t('warehourse.isMain') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/warehourse/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('stock/warehourse/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('stock/warehourse/SET_EDIT_DATA', {})
      this.showForm = false
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('stock/warehourse/destroy', record.location_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/warehourse/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
